<script>
  import ClosableModal from 'root/services/modals/Closable.modal.svelte';
  import SpinnerWithText from 'root/components/molecules/SpinnerWithText.svelte';
  import ModalButtons from 'root/services/modals/ModalButtons.YesNo.svelte';
  import manageUsersService
    , {PENDING_USER_TYPE} from 'vRoot/account-profile/modules/manage-users/services/account-manage-users-list.service';
  import orderBy from 'lodash/orderBy';
  import {notificationUtils, mainAPI} from 'root/angular-injector-provider';

  export let hide, cancel, accountId, company;

  const LOADING = 'Loading';

  let users = LOADING, working = true, setUserId, selected;

  (async function initialize() {
    setUserId = company.primaryAgent.userId;
    let result = await manageUsersService.loadUsers();
    result = result.map(user => {
      user.managedAccountsCount = user.accountsManaged.length;
      if(user.id === setUserId) {
        user.setAsManager = true;
        selected = user.id;
      }
      return user;
    });

    users = orderBy(result, ['setAsManager', 'fullName'], ['asc', 'asc']);
    working = false;
  })();

  function save(){
    if(selected && setUserId !== selected){
      working = true;
      const selectedUser = users.find(user => user.id === selected);
      const userData = {
        userId: selectedUser.id,
        accountId: company.id,
        isUser: selectedUser.type !== PENDING_USER_TYPE,
      }
      notificationUtils().onSave(() => mainAPI().assignAgentToCompany(accountId, userData))
        .then(() => hide(userData));
    }
  }

</script>

<ClosableModal width="500px" close="{cancel}">
  <div slot="heading" class="Heading">
    <div class="Logo">
      {#if company.logo}
        <img src="{`/images/logos/${company.logo}`}" alt="{company.name}" />
      {:else}
        <div data-icon-before="business"></div>
      {/if}
    </div>
    <div class="Details">
      <div class="Title">Assign an account manager</div>
      <div>to { company.name }</div>
    </div>
  </div>
  {#if users === LOADING}
    <div class="Notification">
      <SpinnerWithText />
    </div>
  {:else if !users.length}
    <div class="Notification">
      There are no users to assign!
    </div>
  {:else}
    <div class="Body">
      {#each users as user}
        <div class="User"
             class:ManagedByUser={user.setAsManager}
             class:Selected={selected === user.id}
             data-icon-before="{selected === user.id? 'radio_button_checked': 'radio_button_unchecked'}"
             on:click={() => {selected = user.id}}
        >
          <div class="UserName">{user.fullName}</div>

          {#if user.managedAccountsCount}
            <div>
              Managing {user.managedAccountsCount} Compan{user.managedAccountsCount === 1? 'y': 'ies'}
              <div class="rbTooltip simple" tooltip="placement:top-start">
                <b>Accounts Managed</b><br>
                {#each user.accountsManaged as managedAccount}
                  <div>{managedAccount.accountDetails.name}</div>
                {/each}
              </div>
            </div>
          {:else}
            <div class="Unassigned" data-icon-after="warning">
              Not Assigned
            </div>
          {/if}
        </div>
      {/each}
    </div>
  {/if}

  <ModalButtons
    disabled="{working || !selected || setUserId === selected}"
    noAction="{cancel}"
    noLabel="Cancel"
    yesLabel="Apply Changes"
    yesIcon="account_circle"
    yesAction="{save}"
  />
</ClosableModal>


<style lang="stylus">

  .Heading {
    position: relative;
    padding: 14px 10px 0;
    font-size: 13px;
    color: #78909C;
    font-weight: 600;
    align-items: center;
    display: flex;
  }

  .Logo {
    height: 65px;
    width: 110px;
    object-fit: contain;
    border-radius: 3px;
    border: 1px solid #eceff1;
    background: #eceff1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-right: 10px;
    overflow: hidden;

    div:before {
      color: #37474f;
      font-size: 50px;
    }

    img {
      max-height: 65px;
      max-width: 110px;
    }
  }

  .Title {
    color: #37474f;
    font-size: 16px;
  }


  .Notification {
    padding: 20px;
    font-size: 14px;
    font-weight: bold;
    color #546E7A;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Body {
    max-height: 250px;
    margin: 15px;
    color #546E7A;
    font-size 13px;
    overflow: auto;
    border: 1px solid #b0bec5;
    border-radius: 3px;
  }

  .User {
    display: flex;
    align-items: center;
    height: 42px;
    box-sizing: border-box;
    padding: 10px;

    border-bottom: 1px solid #eceff1;
    cursor: pointer;
    font-size: 13px;

    & > div {
      white-space: nowrap;
    }

    &:hover {
      background rgba(252, 238, 33, 0.08);
    }

    &.Selected {
      background rgba(252, 238, 33, 0.24);
    }


    &:before {
      font-size: 16px;
      margin-right: 5px;
    }
  }

  :nth-last-child(1 of .ManagedByUser) {
    border-bottom 3px solid #CFD8DC;
  }

  .UserName {
    flex: 1 1 100%;
  }

  .Unassigned {
    color: #F15A24;

    &:after {
      margin-left: 3px;
      font-size: 18px;
    }
  }

</style>
